module.exports = __webpack_public_path__ + "img/choose-up-Up Gradinita-disabled.904ffde4.png";